import API, { IRI, defaultHeaders } from '@/api';

const fetchEdit = payload => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;

  return fetch(`${API}/panel/course/${IRI.course}${payload.id}/`, {
    headers,
    method: 'PUT',
    body: JSON.stringify(payload),
  });
};

export default fetchEdit;
